import { Link } from 'react-router-dom';

export function NotFoundPage() {
  return (
    <div className="grid min-h-dvh place-items-center bg-paper px-6">
      <div className="text-center">
        <p className="lbl mb-2">Error 404</p>
        <h1 className="text-2xl">This page does not exist</h1>
        <p className="mx-auto mt-2 max-w-sm text-sm text-ink-2">
          The link may be broken, or the page may have been moved.
        </p>
        {/* Styled as a button but rendered as a link — never nest <a> in <button>. */}
        <Link
          to="/"
          className="mt-6 inline-flex h-11 items-center justify-center rounded-field border border-accent bg-accent px-5 text-base font-[560] text-white transition-colors hover:bg-accent-2"
        >
          Go back home
        </Link>
      </div>
    </div>
  );
}
